import { CSSProperties } from 'react';
import styled, { css } from 'styled-components';
import { formInputStyles } from '../../styles/shareableStyles';
import { theme } from '../../styles/theme';
import SingleSelectLabel from './SingleSelect/SingleSelectLabel';
import { colors } from '../../config/styles';

const BorderedDropdownLabel = styled(SingleSelectLabel)<{
  $customWidth?: CSSProperties['minWidth'];
  $hasError?: boolean;
}>`
  justify-content: space-between;
  min-height: 28px;
  padding-right: 4px;
  padding-left: 8px;
  ${formInputStyles};
  ${({ $customWidth }) =>
    $customWidth &&
    css`
      min-width: ${$customWidth};
    `}
  ${({ $hasError }) =>
    $hasError &&
    css`
      border-color: ${colors.mainError};
    `}
  ${({ isDisabled }) =>
    isDisabled
      ? css`
          opacity: 1;
          color: ${theme.colors.secondary400};
          background-color: ${theme.colors.level1};
          &:hover {
            cursor: not-allowed;
            color: ${theme.colors.secondary400};
            border-color: ${theme.colors.border};
          }
        `
      : css`
          &:hover {
            border-color: ${theme.colors.mainBlue};
            cursor: pointer;
          }
        `}
  &[aria-expanded='true'],
  [aria-expanded='true'] &,
  [data-open='true'] & {
    border-color: ${theme.colors.mainBlue};
  }
`;

export default BorderedDropdownLabel;
